/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_IntroInputs */

const en_viewer_intro = /** @type {(inputs: Viewer_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore JSON as a collapsible tree with the raw text beside it. Types are labelled, so you can tell an empty string from a null and a number from a numeric string at a glance.`)
};

const ko_viewer_intro = /** @type {(inputs: Viewer_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 접을 수 있는 트리로 살펴보고 원문을 나란히 봅니다. 타입에 이름이 붙으므로 빈 문자열과 null, 숫자와 숫자처럼 보이는 문자열을 한눈에 구분할 수 있습니다.`)
};

const ja_viewer_intro = /** @type {(inputs: Viewer_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON を折りたためるツリーとして探索し、生のテキストを横に並べて見ます。型にラベルが付くので、空文字列と null、数値と数値に見える文字列を一目で区別できます。`)
};

/**
* | output |
* | --- |
* | "Explore JSON as a collapsible tree with the raw text beside it. Types are labelled, so you can tell an empty string from a null and a number from a numeric s..." |
*
* @param {Viewer_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_intro = /** @type {((inputs?: Viewer_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_intro(inputs)
	if (locale === "ko") return ko_viewer_intro(inputs)
	return ja_viewer_intro(inputs)
});